import template from './tab-header.html';

export default class TabHeaderComponent {
  constructor() {
    this.template = template;
    this.controller = () => {};
    this.bindings = {
      isActive: '<',
      activeTabId: '<',
      headerText: '@',
      onSelect: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/tab/components/tab-header/tab-header-component.js